import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/NineSystemsGrid.css';

interface SystemInfo {
  id: string;
  name: string;
  status: string;
  icon: string;
  issues: string[];
  riskLevel: string;
}

interface NineSystemsGridProps {
  className?: string;
}

const NineSystemsGrid: React.FC<NineSystemsGridProps> = ({ className }) => {
  const navigate = useNavigate();

  const healthSystems: SystemInfo[] = [
    {
      id: 'digestive',
      name: '消化系统',
      status: 'warning',
      icon: '👍',
      issues: ['幽门螺旋杆菌阳性', '脂肪肝', '胃炎轻度', '消化不良', '肠易激综合征', '胆囊息肉'],
      riskLevel: '重点监测'
    },
    {
      id: 'respiratory',
      name: '呼吸系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'nervous',
      name: '神经系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'circulatory',
      name: '循环系统',
      status: 'caution',
      icon: '👍',
      issues: ['高血压风险提醒'],
      riskLevel: '常规预警'
    },
    {
      id: 'endocrine',
      name: '内分泌系统',
      status: 'caution',
      icon: '👍',
      issues: ['2型糖尿病风险预警'],
      riskLevel: '常规预警'
    },
    {
      id: 'motor',
      name: '运动系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'urinary',
      name: '泌尿系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'reproductive',
      name: '生殖系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'immune',
      name: '免疫系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'normal': return '#34c759';
      case 'caution': return '#ffcc00';
      case 'warning': return '#ff9500';
      case 'danger': return '#ff3b30';
      default: return '#34c759';
    }
  };

  const getStatusBgColor = (status: string) => {
    switch (status) {
      case 'normal': return '#f0f9f0';
      case 'caution': return '#fff8e6';
      case 'warning': return '#fff0f0';
      case 'danger': return '#fff0f0';
      default: return '#f0f9f0';
    }
  };

  const handleSystemClick = (system: SystemInfo) => {
    navigate(`/system/${system.id}`);
  };

  return (
    <div className={`nine-systems-container ${className || ''}`}>
      {/* 九宫格系统展示 */}
      <div className="nine-grid-inline">
        {healthSystems.map((system) => (
          <div 
            key={system.id} 
            className={`system-card-inline ${system.status} clickable`}
            style={{ backgroundColor: getStatusBgColor(system.status) }}
            onClick={() => handleSystemClick(system)}
          >
            <div className="system-header-inline">
              <h5 className="system-name-inline">{system.name}</h5>
            </div>
            
            <div className="system-content-inline">
              {system.issues.length > 0 ? (
                <ul className="issue-list-inline">
                  {system.issues.slice(0, 3).map((issue, index) => (
                    <li key={index} className="issue-item-inline" title={issue}>{issue}</li>
                  ))}
                  {system.issues.length > 3 && (
                    <li className="more-issues-inline">
                      +{system.issues.length - 3} 更多
                    </li>
                  )}
                </ul>
              ) : (
                <div className="normal-status-inline">
                  <div className="thumbs-up-inline">
                    ✓
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* 状态说明图例 */}
      <div className="legend-container-inline">
        <div className="legend-item-inline">
          <div className="legend-color-inline danger"></div>
          <span className="legend-text-inline">立即就医</span>
        </div>
        <div className="legend-item-inline">
          <div className="legend-color-inline warning"></div>
          <span className="legend-text-inline">重点检查</span>
        </div>
        <div className="legend-item-inline">
          <div className="legend-color-inline caution"></div>
          <span className="legend-text-inline">常规</span>
        </div>
        <div className="legend-item-inline">
          <div className="legend-color-inline normal"></div>
          <span className="legend-text-inline">保持</span>
        </div>
      </div>


    </div>
  );
};

export default NineSystemsGrid; 